<template>
  <v-container>
    <v-content>
      <h1 class="text-center primary--text pt-4">
        Produktionshistorie
      </h1>
    </v-content>
    <v-row cols="12">
      <v-col cols="12" sm="12">
        <HistoryTable></HistoryTable>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import HistoryTable from '../components/tables/HistoryTable'

export default {
  components: {
    HistoryTable
  },
  data: () => ({
    content: {}
  }),
  created: function() {},
  methods: {}
}
</script>
